import React from 'react'
import "./Testimonials.scss";
import { homePageData } from "../../../data/data";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { Typography, MobileStepper, Button } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function Testimonials() {
  const { testimonials } = homePageData;

  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = testimonials.length;

  const handleNext = () =>
    setActiveStep((prevStep) => (prevStep + 1) % maxSteps);
  const handleBack = () =>
    setActiveStep((prevStep) => (prevStep - 1 + maxSteps) % maxSteps);
  const handleStepChange = (step) => setActiveStep(step);

  return (
    <div className="testimonials-section">
      <Typography variant="h4" className="testimonials-section-title">
        Testimonials
      </Typography>
      <div className="carousel-container">
        <AutoPlaySwipeableViews
          index={activeStep}
          onChangeIndex={handleStepChange}
          interval={10000}
        >
          {testimonials.map(({ name, testimony }, index) => (
            <div
              key={index}
              className="carousel-item"
              style={{ display: activeStep === index ? "block" : "none" }}
            >
              <h3>{name}</h3>
              <Typography variant="body1">{testimony}</Typography>
            </div>
          ))}
        </AutoPlaySwipeableViews>
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button size="small" onClick={handleNext}>
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack}>
              <KeyboardArrowLeft />
            </Button>
          }
        />
      </div>
    </div>
  );
}

export default Testimonials;
